import Icon from '../components/Icon.vue'

Icon.register({"mars-stroke-v":{"width":288,"height":512,"paths":[{"d":"M245.8 234.2C225.9 214.3 201.6 201.4 176 195.6V170.2H196C202.6 170.2 208 164.8 208 158.2V118.2C208 111.6 202.6 106.2 196 106.2H176V81.4H199.9C210.6 81.4 215.9 68.5 208.4 60.9L152.5 5.1C147.8 0.4 140.2 0.4 135.5 5.1L79.6 61C72 68.6 77.4 81.5 88.1 81.5H112V106.2H92C85.4 106.2 80 111.6 80 118.2V158.2C80 164.8 85.4 170.2 92 170.2H112V195.6C86.4 201.4 62.1 214.3 42.2 234.2-14 290.4-14 381.6 42.2 437.8 98.4 494 189.6 494 245.8 437.8 302.1 381.6 302.1 290.4 245.8 234.2zM200.6 392.6C169.4 423.8 118.7 423.8 87.5 392.6 56.3 361.4 56.3 310.7 87.5 279.5 118.7 248.3 169.4 248.3 200.6 279.5 231.8 310.6 231.8 361.4 200.6 392.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mars-stroke-v.js
// module id = XBkl
// module chunks = 0